module.exports = __webpack_public_path__ + "static/flags/MU-d06865dc9f389b37f911f155802558b7.gif";